<template>

    <div class="card-body chat-body">
        <chat-message v-for="message in messages" :key="message.id" :message = "message" :is-own-message = "authId !== message['sender_user_id']"></chat-message>
    </div>
</template>

<script>
    export default {
        name: "ChatComponent",
        data() {
            return {
                messages: [],
            }
        },
        props: {
            conversationId: String,
            authId : String,
            previousMessages: Array
        },
        mounted() {
                this.messages = this.previousMessages;
                Echo.channel(`conversation.${this.conversationId}`)
                    .listen('ChatMessageReceived', (e) => {
                        this.messages.push(e.chatMessage);
                    });
        },
    }
</script>

<style scoped>

</style>
